import { Base } from './base';
import { EventStatus } from './event';

export enum DrawerTestimonial {
	Edit = 'Edit Testimonial',
	Create = 'Create Testimonial',
}
export interface ITestimonial extends Base {
	name: string;
	email: string | null;
	mobile: string | null;
	address: string | null;
	organization: string | null;
	status: EventStatus;
	img: string | null;
	comments: string;
    createdBy:string;
}
export interface ITestimonialDto {
	name: string;
	email: string | null;
	mobile: string | null;
	address: string | null;
	organization: string | null;
	img: string | null | File;
	comments: string;
}
